import type { IconSvgObject } from './types';

const ScissorsLineDashedIcon: IconSvgObject = [
  ["path", { d: "M13.4922 12H15.4922", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.4922 12H21.4922", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "4.49219", cy: "8", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6.49219 10L8.49219 12M13.4922 17L10.9922 14.5M6.49219 14L8.49219 12M13.4922 7L8.49219 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["circle", { cx: "4.49219", cy: "16", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default ScissorsLineDashedIcon;
